var debug = false;

if (debug) {
  console.log("video js");
}


const inlineVideo = () => {
  const playInline = (selector, parentDiv) => {
    const videoBtns = Array.from(document.querySelectorAll(selector));
    videoBtns.forEach((videoBtn) => {
      var imageWrapper = videoBtn.closest(parentDiv);
      var videoWrapper = imageWrapper.querySelector(".video-wrapper");

      videoBtn.addEventListener("click", (e) => {
        if (debug) {
          console.log("inlineVideo, playinline", "clicked");
        }
        imageWrapper.classList.add("-show");
        videoWrapper.addEventListener("transitionend", () => {
          videoBtn.classList.add("-hide");
        });
      });
    });
  };

  //TODO: Youtube API, play video when button clicked

  playInline(".video-link__inline", ".image-wrap--video");
};

inlineVideo();
